/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useCallback } from "react";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";

import { columnTextField } from "utils/tables-utils";

const columnModel = [
  columnTextField(
    {
      dataField: "Apelido",
      text: "Nome da Loja",
    },
    false
  ),
  columnTextField(
    {
      dataField: "IdPedido",
      text: "Pedido",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "Status",
      text: "Status",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "TipoProblemaFormat",
      text: "Tipo Problema",
      align: "center",
    },
    false
  ),
];

const TableRegistroProblemaPI = ({
  dataTable,
  totalRegistros,
  currentPage,
  currentSizePerPage,
  search,
  setShowDetail,
  setSelectedOrder,
}) => {
  const [loading, setLoading] = useState(false);

  const doSearch = useCallback(async (page, sizePerPage) => {
    setLoading(true);
    await search({ page, sizePerPage });
    setLoading(false);
  }, []);

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSelectOrder = (data) => {
    setSelectedOrder(data);
    setShowDetail(true);
  };

  return (
    <ToolkitTable
      searched={Boolean(dataTable)}
      keyField="Numero"
      dataTable={dataTable}
      columnModel={columnModel}
      loading={loading}
      pagination={{
        options: [25, 50, 100],
        defaultOption: currentSizePerPage,
        totalSize: totalRegistros,
        showTotal: false,
        page: currentPage,
        onPageChange: handlePageChange,
        sizePerPage: currentSizePerPage,
        onSizePerPageChange: handleSizePerPageChange,
      }}
      onRowClick={(_, row) => handleSelectOrder(row)}
      notFoundTitle="Sua pesquisa não encontrou Problemas Operacionais correspondentes."
      bootstrapTableProps={{
        remote: true,
        onTableChange: () => {},
      }}
    />
  );
};

export { TableRegistroProblemaPI };
